<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data Inicial"
              v-model="dt_ini"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data Final"
              v-model="dt_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from 'moment';
export default {
  components: {
    Multiselect,
  },
  props: {
    tabela: "",
  },
  data() {
    return {
      helpForm: new Form({ params: [] }),
      dt_ini: "",
      dt_fim: "",
      dt_emi_ini_label: '',
      dt_emi_fim_label: '',
      data_filter: [],
    };
  },
  mounted() {
    this.getStatus();
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.dt_ini_label = this.dt_ini;
      this.dt_fim_label = this.dt_fim;
      this.dt_ini = this.formatDateSubmit(this.dt_ini);
      this.dt_fim = this.formatDateSubmit(this.dt_fim);
      this.data_filter = { 
        dt_ini: this.dt_ini, 
        dt_fim: this.dt_fim 
      };
      this.$events.fire("filter-set", this.data_filter);
      this.dt_ini = this.dt_ini_label;
      this.dt_fim = this.dt_fim_label;
    },
    resetFilter() {
      this.dt_ini = ""; // clear the text in text input
      this.dt_fim = "";
      this.$events.fire("filter-reset");
    },
    formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
      return (value == null || value == "")
          ? ''
          : moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>
